import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { getKeyByPath } from '@tencent/memoire-core';
import { IntervalMath } from '../algorithm/interval';
import KeyInterval from '../key-interval';
import { createContext } from './query-job';
var QueryJobIndexScan = /** @class */ (function () {
    function QueryJobIndexScan(node, parent, transaction) {
        this.node = node;
        this.parent = parent;
        this.transaction = transaction;
        this.context = createContext(node);
    }
    QueryJobIndexScan.prototype.perform = function (output) {
        return __awaiter(this, void 0, void 0, function () {
            var keys_1, keyPath, values_1, keys, values;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.node.hydrate) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.scanKeys()];
                    case 1:
                        keys_1 = _a.sent();
                        output.push(keys_1.map(function (key) { return [key, undefined]; }));
                        return [2 /*return*/];
                    case 2:
                        keyPath = this.node.collectionSchema.key.path;
                        if (!keyPath) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.scanValues()];
                    case 3:
                        values_1 = _a.sent();
                        output.push(values_1.map(function (value) { return [getKeyByPath(value, keyPath), value]; }));
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, this.scanKeys()];
                    case 5:
                        keys = _a.sent();
                        return [4 /*yield*/, this.scanValues()];
                    case 6:
                        values = _a.sent();
                        output.push(keys.map(function (key, i) { return [key, values[i]]; }));
                        return [2 /*return*/];
                }
            });
        });
    };
    QueryJobIndexScan.prototype.scanKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queries, index, keySegments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queries = this.getKeyQueries();
                        index = this.getIndex();
                        return [4 /*yield*/, Promise.all(queries.map(function (query) { return index.getAllKeys(query); }))];
                    case 1:
                        keySegments = _a.sent();
                        return [2 /*return*/, keySegments.reduce(function (prev, keys) {
                                prev.push.apply(prev, __spreadArray([], __read(keys)));
                                return prev;
                            }, [])];
                }
            });
        });
    };
    QueryJobIndexScan.prototype.scanValues = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queries, index, valueSegments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queries = this.getKeyQueries();
                        index = this.getIndex();
                        return [4 /*yield*/, Promise.all(queries.map(function (query) { return index.getAll(query); }))];
                    case 1:
                        valueSegments = _a.sent();
                        return [2 /*return*/, valueSegments.reduce(function (prev, keys) {
                                prev.push.apply(prev, __spreadArray([], __read(keys)));
                                return prev;
                            }, [])];
                }
            });
        });
    };
    QueryJobIndexScan.prototype.getKeyQueries = function () {
        var imath = new IntervalMath(this.node.comparer);
        return this.node.intervals.map(function (interval) { return KeyInterval.getKeyRange(imath, interval); });
    };
    QueryJobIndexScan.prototype.getIndex = function () {
        var _a = this.node, collectionSchema = _a.collectionSchema, index = _a.index;
        var store = this.transaction.table(collectionSchema.name);
        return store.index(index.name);
    };
    return QueryJobIndexScan;
}());
export { QueryJobIndexScan };
export default QueryJobIndexScan;
//# sourceMappingURL=query-job-index-scan.js.map